import HomePage from '../containers/Home/index';
import Register from '../containers/Register/index';
import InitialSetup from '../containers/InitialSetup/index';
//import GetStarted from '../containers/GetStarted/index';
//import Engage from '../containers/Engage';

import ConversationFlow from '../containers/A_ConversationFlow';

import Handoff from '../containers/B_HandOff';
import Outreach from '../containers/C_Outreach';
import Config from '../containers/D_OtherConfig';
import BotConfig from '../containers/BotConfig';
import Dashboard from '../containers/Dashboard';
import ChatHistory from '../containers/ChatHistory';
import Channels from '../containers/Channels';
import Permissions from '../containers/Permissions';
import FB_Page from '../containers/FB_Page';

//Bots
import QueryBot from '../containers/Bot_Query';
import AppointmentBot from '../containers/Bot_Appointment';
import GeneralBot from '../containers/Bot_General';

export const ROUTE_NAMES = {
    home: '/',
    register: '/register',
    initialSetup: '/initialsetup',
    //engage: '/engage',
    conversationFlow:'/conversationFlow',
    handoff:'/handoff',
    outreach:'/outreach',
    config:'/config',
    bot_config:'/bot_config',
    chat_history:'/chat_history',
    dashboard:'/dashboard',
    query_bot:'/queryBot',
    appointment_bot:'/appointmentBot',
    general_bot:'/generalBot',
    channels:'/channels',
    permissions:'/permissions',
    fb_page:'/fb_page'
}

export const ROUTES = [
    {
        title: 'Home',
        key: 'home',
        link: ROUTE_NAMES.home,
        isFullPageLayout :true,
        component: HomePage,
    },
    {
        title: 'Permissions',
        key: 'permissions',
        link: ROUTE_NAMES.permissions,
        isFullPageLayout :true,
        component: Permissions,
    },

    {
        title: 'Register',
        key: 'register',
        link: ROUTE_NAMES.register,
        isFullPageLayout :true,
        component: Register
    },
    {
        title: 'Dashboard',
        key: 'dashboard',
        link: ROUTE_NAMES.dashboard,
        component: Dashboard,
        isSideBarItem: true,
        icon: 'mdi mdi-home menu-icon',
        isPrivate: true
    },

    // {
    //     title: 'Conversation flow workspace',
    //     key: 'configConversationFlow',
    //     link: ROUTE_NAMES.conversationFlow,
    //     component: ConversationFlow,
    //     isSideBarItem: false,
    //     isPrivate: true
    // },
    // {
    //     title: 'Human hand-off',
    //     key: 'handoff',
    //     link: ROUTE_NAMES.handoff,
    //     component: Handoff,
    //     isSideBarItem: false,
    //     isPrivate: true
    // },
    // {
    //     title: 'Outreach',
    //     key: 'outreach',
    //     link: ROUTE_NAMES.outreach,
    //     component: Outreach,
    //     isSideBarItem: false,
    //     isPrivate: true
    // },
    // {
    //     title: 'Other set up',
    //     key: 'config',
    //     link: ROUTE_NAMES.config,
    //     component: Config,
    //     isSideBarItem: false,
    //     isPrivate: true
    // },
    
    {
        title: 'Channels',
        key: 'channels',
        link: ROUTE_NAMES.channels,
        component: Channels,
        isSideBarItem: true,
        icon: 'mdi mdi-layers menu-icon',
        isPrivate: true
    },
    {
        title: 'Chat history',
        key: 'chat_history',
        link: ROUTE_NAMES.chat_history,
        component: ChatHistory,
        isSideBarItem: true,
        icon: 'mdi mdi-snapchat menu-icon',
        isPrivate: true
    },
    {
        title: 'Initial setup',
        key: 'initialSetup',
        link: ROUTE_NAMES.initialSetup,
        component: InitialSetup,
        isFullPageLayout :true,
        // isSideBarItem: false,
        // isPrivate: true
    },
    {
        title: 'Query bot',
        key: 'queryBot',
        link: ROUTE_NAMES.query_bot,
        component: QueryBot,
        isSideBarItem: false,
        isPrivate: true
    },
    {
        title: 'Appointment bot',
        key: 'appointmentBot',
        link: ROUTE_NAMES.appointment_bot,
        component: AppointmentBot,
        isSideBarItem: false,
        isPrivate: true
    },
    {
        title: 'General bot',
        key: 'generalBot',
        link: ROUTE_NAMES.general_bot,
        component: GeneralBot,
        isSideBarItem: false,
        isPrivate: true
    },

    {
        title: 'FB Page',
        key: 'fbPage',
        link: ROUTE_NAMES.fb_page,
        component: FB_Page,
        // isSideBarItem: false,
        // isPrivate: true
    },
   /* {
        title: 'Get started',
        key: 'getStarted',
        link: ROUTE_NAMES.getStarted,
        component: GetStarted,
        isSideBarItem: true,
        isPrivate: true
    },
    {
        title: 'Engage',
        key: 'engage',
        link: ROUTE_NAMES.engage,
        component: Engage,
        isSideBarItem: true,
        isPrivate: true
    },
    {
        title: 'Bot config',
        key: 'bot_config',
        link: ROUTE_NAMES.bot_config,
        component: BotConfig,
        isSideBarItem: false,
        icon: 'mdi mdi-settings menu-icon',
        isPrivate: true
    },
    */
    {
        // default page
        title: 'Home',
        key: 'home',
        isFullPageLayout :true,
        component: HomePage
    },
]
